const routes = [
	...require('./features/site/routes').default,
];

export default routes;
